import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { colors, font, LoadingIcon, ScaleAnimation, spacing, visuallyHiddenCss, gradient } from '@chegg-ui/theme';
import styled, { css } from 'styled-components';

var getDefaultSizeConfig = function getDefaultSizeConfig(theme, _ref) {
  var _ref$xlarge = _ref.xlarge,
      xlarge = _ref$xlarge === void 0 ? {} : _ref$xlarge,
      _ref$large = _ref.large,
      large = _ref$large === void 0 ? {} : _ref$large,
      _ref$medium = _ref.medium,
      medium = _ref$medium === void 0 ? {} : _ref$medium,
      _ref$small = _ref.small,
      small = _ref$small === void 0 ? {} : _ref$small,
      _ref$xsmall = _ref.xsmall,
      xsmall = _ref$xsmall === void 0 ? {} : _ref$xsmall;
  return {
    xlarge: _objectSpread({
      fontSize: theme.font.size.lg,
      fontWeight: theme.font.weight.bold,
      letterSpacing: theme.font.letterSpacing.md,
      padding: "".concat(16 / 16, "rem ").concat(22 / 16, "rem ").concat(14 / 16, "rem"),
      loaderSize: 'medium'
    }, xlarge),
    large: _objectSpread({
      fontSize: theme.font.size.lg,
      fontWeight: theme.font.weight.bold,
      letterSpacing: theme.font.letterSpacing.md,
      padding: "".concat(12 / 16, "rem ").concat(22 / 16, "rem ").concat(10 / 16, "rem"),
      loaderSize: 'medium'
    }, large),
    medium: _objectSpread({
      fontSize: theme.font.size.lg,
      fontWeight: theme.font.weight.bold,
      letterSpacing: theme.font.letterSpacing.md,
      padding: "".concat(8 / 16, "rem ").concat(22 / 16, "rem ").concat(6 / 16, "rem"),
      loaderSize: 'small'
    }, medium),
    small: _objectSpread({
      fontSize: theme.font.size.xs,
      fontWeight: theme.font.weight.medium,
      letterSpacing: theme.font.letterSpacing.md,
      padding: "".concat(8 / 16, "rem ").concat(22 / 16, "rem ").concat(6 / 16, "rem"),
      loaderSize: 'small'
    }, small),
    xsmall: _objectSpread({
      fontSize: theme.font.size.xs,
      fontWeight: theme.font.weight.medium,
      letterSpacing: theme.font.letterSpacing.md,
      padding: "".concat(3 / 16, "rem ").concat(14 / 16, "rem"),
      loaderSize: 'xsmall'
    }, xsmall)
  };
};

var getFantaSizeConfig = function getFantaSizeConfig(_ref2) {
  var _ref2$xlarge = _ref2.xlarge,
      xlarge = _ref2$xlarge === void 0 ? {} : _ref2$xlarge,
      _ref2$large = _ref2.large,
      large = _ref2$large === void 0 ? {} : _ref2$large,
      _ref2$medium = _ref2.medium,
      medium = _ref2$medium === void 0 ? {} : _ref2$medium,
      _ref2$small = _ref2.small,
      small = _ref2$small === void 0 ? {} : _ref2$small,
      _ref2$xsmall = _ref2.xsmall,
      xsmall = _ref2$xsmall === void 0 ? {} : _ref2$xsmall;
  return {
    xlarge: _objectSpread({
      padding: "".concat(18 / 16, "rem ").concat(22 / 16, "rem")
    }, xlarge),
    large: _objectSpread({
      fontSize: font.size.px24,
      padding: "".concat(12 / 16, "rem 1rem"),
      letterSpacing: 'initial'
    }, large),
    medium: _objectSpread({
      fontSize: font.size.px20,
      padding: "".concat(10 / 16, "rem 1rem"),
      letterSpacing: 'initial',
      loaderSize: 'medium'
    }, medium),
    small: _objectSpread({
      fontSize: font.size.px20,
      padding: "".concat(6 / 16, "rem 1rem"),
      letterSpacing: 'initial',
      fontWeight: font.weight.bold
    }, small),
    xsmall: _objectSpread({
      fontSize: font.size.px16,
      padding: "".concat(4 / 16, "rem ").concat(12 / 16, "rem"),
      letterSpacing: 'initial',
      fontWeight: font.weight.bold
    }, xsmall)
  };
};

export var VisuallyHidden = styled.span.withConfig({
  componentId: "sc-1eq90u-0"
})(["", ""], visuallyHiddenCss);
export var LoadingIconWrapper = styled(LoadingIcon).withConfig({
  componentId: "sc-1eq90u-1"
})(["margin-left:", ";margin-top:3px;"], spacing.px8);
export var ButtonContentWrapper = styled.span.withConfig({
  componentId: "sc-1eq90u-2"
})(["display:flex;flex-direction:column;font-size:inherit;"]);
export var LeadingIconWrapper = styled.span.withConfig({
  componentId: "sc-1eq90u-3"
})(["display:flex;margin-right:", ";"], function (_ref3) {
  var hasChildren = _ref3.hasChildren;
  return hasChildren ? spacing.px8 : 0;
});
export var TrailingIconWrapper = styled.span.withConfig({
  componentId: "sc-1eq90u-4"
})(["display:flex;margin-left:", ";", ""], spacing.px8, function (_ref4) {
  var alignTrailingIconToRight = _ref4.alignTrailingIconToRight;
  return alignTrailingIconToRight ? "flex-grow: 1;" : '';
});
export var ButtonContent = styled.span.withConfig({
  componentId: "sc-1eq90u-5"
})(["align-items:center;display:inline-flex;font-size:inherit;justify-content:center;white-space:nowrap;visibility:", ";height:", ";overflow:", ";"], function (_ref5) {
  var isVisible = _ref5.isVisible;
  return isVisible ? 'visible' : 'hidden';
}, function (_ref6) {
  var isVisible = _ref6.isVisible,
      size = _ref6.size,
      customTheme = _ref6.customTheme;
  return isVisible ? "".concat(parseFloat(customTheme[size].fontSize) * customTheme.lineHeight, "rem") : '0';
}, function (_ref7) {
  var isVisible = _ref7.isVisible;
  return isVisible ? 'visible' : 'hidden';
});
export var LoadingText = styled.span.withConfig({
  componentId: "sc-1eq90u-6"
})(["font-size:inherit;"]);
var hoverAnimation = css([":hover{", " & > span:first-of-type{", "}}:not(:hover),:active{", " & > span:first-of-type{", "}}"], ScaleAnimation(), ScaleAnimation({
  scaleTarget: '0.95'
}), ScaleAnimation({
  scaleTarget: '1'
}), ScaleAnimation({
  scaleTarget: '1'
}));

var getButtonState = function getButtonState(_ref8) {
  var customTheme = _ref8.customTheme,
      size = _ref8.size,
      variant = _ref8.variant,
      key = _ref8.key;
  return customTheme[variant || size][key] || customTheme[key];
};

var getButtonStateMixin = function getButtonStateMixin(key) {
  return css(["", ""], function (_ref9) {
    var customTheme = _ref9.customTheme,
        size = _ref9.size,
        variant = _ref9.variant;
    return getButtonState({
      customTheme: customTheme,
      size: size,
      variant: variant,
      key: key
    });
  });
};

var getBorderAndBoxShadowMixin = function getBorderAndBoxShadowMixin(state) {
  return css(["", ""], function (_ref10) {
    var customTheme = _ref10.customTheme,
        size = _ref10.size,
        variant = _ref10.variant;
    var border = '';
    var borderWidth = getButtonState({
      customTheme: customTheme,
      size: size,
      variant: variant,
      key: "".concat(state, "BorderWidth")
    });
    var boxShadow = getButtonState({
      customTheme: customTheme,
      size: size,
      variant: variant,
      key: "".concat(state, "BoxShadow")
    });

    if (borderWidth) {
      var borderColor = getButtonState({
        customTheme: customTheme,
        size: size,
        variant: variant,
        key: "".concat(state, "BorderColor")
      });
      border = "0 0 0 ".concat(borderWidth, " ").concat(borderColor, " inset");
    }

    if (boxShadow) {
      return border ? "box-shadow: ".concat(border, ", ").concat(boxShadow, ";") : "box-shadow: ".concat(boxShadow, ";");
    }

    return "box-shadow: ".concat(border, ";");
  });
};

var ButtonStatesMixin = css(["background:", ";color:", ";", " ", ""], getButtonStateMixin('defaultBackgroundColor'), getButtonStateMixin('defaultTextColor'), function (_ref11) {
  var isLoading = _ref11.isLoading,
      disabled = _ref11.disabled,
      customTheme = _ref11.customTheme;
  return isLoading || disabled ? css(["", " cursor:default;", ";"], isLoading && customTheme.useHoverStateForLoading ? css(["background:", ";color:", ";", ""], getButtonStateMixin('hoverBackgroundColor'), getButtonStateMixin('hoverTextColor'), getBorderAndBoxShadowMixin('hover')) : css(["background:", ";color:", ";", ""], getButtonStateMixin('disabledBackgroundColor'), getButtonStateMixin('disabledTextColor'), getBorderAndBoxShadowMixin('disabled')), customTheme.hoverTextDecoration ? "\n          &:focus,\n          &:hover,\n          &:active {\n            text-decoration: none;\n          }\n        " : "") : css(["", ":hover,:active{background:", ";color:", ";", " cursor:pointer;", ";}"], getBorderAndBoxShadowMixin('default'), getButtonStateMixin('hoverBackgroundColor'), getButtonStateMixin('hoverTextColor'), getBorderAndBoxShadowMixin('hover'), customTheme.hoverTextDecoration ? "text-decoration: ".concat(customTheme.hoverTextDecoration) : "");
}, function (_ref12) {
  var disableHoverAnimation = _ref12.disableHoverAnimation,
      isLoading = _ref12.isLoading,
      disabled = _ref12.disabled;
  return disableHoverAnimation || isLoading || disabled ? '' : hoverAnimation;
});
export var ButtonContainer = styled.button.withConfig({
  componentId: "sc-1eq90u-7"
})(["align-items:center;border-radius:2rem;display:inline-flex;justify-content:center;font-family:", ";border:0;", " margin:0;overflow:visible;text-transform:none;-webkit-appearance:button;cursor:pointer;:disabled{cursor:default;}"], font.family["default"], function (_ref13) {
  var size = _ref13.size,
      customTheme = _ref13.customTheme,
      width = _ref13.width;
  return "\n    ".concat(width ? "width: ".concat(width, ";") : '', "\n    font-weight: ").concat(customTheme[size].fontWeight, ";\n    font-size: ").concat(customTheme[size].fontSize, ";\n    padding: ").concat(customTheme[size].padding, ";\n    line-height: ").concat(customTheme.lineHeight, ";\n    letter-spacing: ").concat(customTheme[size].letterSpacing, ";\n  ");
});
export var getPrimaryThemeConfig = function getPrimaryThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return _objectSpread({
        lineHeight: 1.3,
        useHoverStateForLoading: true,
        defaultBorderColor: colors.cheggOrange,
        defaultBackgroundColor: gradient.horizon,
        defaultTextColor: colors.white,
        hoverBorderColor: colors.orange500,
        hoverBackgroundColor: colors.orange900,
        hoverTextColor: colors.white,
        disabledBorderColor: colors.grey200,
        disabledBackgroundColor: colors.grey200,
        disabledTextColor: colors.grey600
      }, getDefaultSizeConfig(theme, {}));
    },
    fanta: _objectSpread({
      defaultBackgroundColor: colors.cheggOrange,
      lineHeight: 1,
      useHoverStateForLoading: false,
      hoverBorderColor: colors.orangeDark,
      hoverBackgroundColor: colors.orangeDark,
      disabledBorderColor: colors.greyXlight,
      disabledBackgroundColor: colors.greyXlight,
      disabledTextColor: colors.grey
    }, getFantaSizeConfig({})),
    prop: themeProp
  };
};
export var PrimaryButtonContainer = styled(ButtonContainer).withConfig({
  componentId: "sc-1eq90u-8"
})(["&&{", "}"], ButtonStatesMixin);
var OutlineButtonConfigs = {
  defaultBorderWidth: "".concat(1 / 16, "rem"),
  defaultBorderColor: colors.grey900,
  defaultBackgroundColor: colors.white,
  defaultTextColor: colors.grey900,
  hoverBorderWidth: "".concat(2 / 16, "rem"),
  hoverBorderColor: colors.grey800,
  hoverBackgroundColor: colors.grey100,
  hoverTextColor: colors.grey900,
  disabledBorderWidth: '',
  disabledBorderColor: colors.grey200,
  disabledBackgroundColor: colors.grey200,
  disabledTextColor: colors.grey600
};
export var getOutlineThemeConfig = function getOutlineThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return _objectSpread(_objectSpread({
        lineHeight: 1.3,
        useHoverStateForLoading: true
      }, OutlineButtonConfigs), getDefaultSizeConfig(theme, {}));
    },
    fanta: _objectSpread({
      lineHeight: 1,
      useHoverStateForLoading: false,
      defaultBorderWidth: "".concat(2 / 16, "rem"),
      defaultBorderColor: colors.cheggOrange,
      defaultTextColor: colors.cheggOrange,
      hoverBorderColor: colors.orangeDark,
      hoverBorderWidth: "".concat(2 / 16, "rem"),
      hoverBackgroundColor: colors.orangeDark,
      hoverTextColor: colors.white,
      disabledBorderWidth: "".concat(2 / 16, "rem"),
      disabledBorderColor: colors.greyXlight,
      disabledBackgroundColor: colors.white,
      disabledTextColor: colors.grey
    }, getFantaSizeConfig({
      xsmall: {
        defaultBorderColor: colors.greyMedium,
        defaultTextColor: colors.dark,
        hoverBorderColor: colors.greyMedium,
        hoverBackgroundColor: colors.white,
        hoverTextColor: colors.dark,
        hoverBoxShadow: "0 0 0 2px ".concat(colors.greyMedium)
      }
    })),
    prop: themeProp
  };
};
export var OutlineButtonContainer = styled(ButtonContainer).withConfig({
  componentId: "sc-1eq90u-9"
})(["&&{", "}"], ButtonStatesMixin);
export var getReverseThemeConfig = function getReverseThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return _objectSpread(_objectSpread({
        lineHeight: 1.3,
        useHoverStateForLoading: true
      }, OutlineButtonConfigs), getDefaultSizeConfig(theme, {}));
    },
    fanta: _objectSpread({
      lineHeight: 1,
      useHoverStateForLoading: false,
      defaultBorderWidth: 0,
      defaultTextColor: colors.dark,
      hoverBorderWidth: 0,
      hoverBackgroundColor: colors.greyLight,
      hoverTextColor: colors.dark,
      disabledBorderWidth: 0,
      disabledBackgroundColor: colors.greyXlight,
      disabledTextColor: colors.grey
    }, getFantaSizeConfig({})),
    prop: themeProp
  };
};
export var ReverseButtonContainer = styled(ButtonContainer).withConfig({
  componentId: "sc-1eq90u-10"
})(["&&{", "}"], ButtonStatesMixin);
export var getSecondaryThemeConfig = function getSecondaryThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return _objectSpread({
        lineHeight: 1.3,
        useHoverStateForLoading: true,
        "default": {
          defaultBackgroundColor: colors.grey900,
          defaultTextColor: colors.white,
          hoverBackgroundColor: colors.grey800,
          hoverTextColor: colors.white,
          disabledBackgroundColor: colors.grey200,
          disabledTextColor: colors.grey600
        },
        text: {
          defaultBackgroundColor: colors.transparent,
          defaultTextColor: colors.violet700,
          hoverBackgroundColor: colors.violet100,
          hoverTextColor: colors.violet700,
          disabledBackgroundColor: colors.transparent,
          disabledTextColor: colors.grey600
        },
        outlined: OutlineButtonConfigs
      }, getDefaultSizeConfig(theme, {}));
    },
    fanta: _objectSpread({
      lineHeight: 1,
      useHoverStateForLoading: true,
      text: {
        defaultTextColor: colors.link,
        hoverBackgroundColor: colors.transparent,
        hoverTextColor: colors.link,
        disabledTextColor: colors.tealMedium
      },
      hoverTextDecoration: 'underline'
    }, getFantaSizeConfig({})),
    prop: themeProp
  };
};
export var SecondaryButtonContainer = styled(ButtonContainer).withConfig({
  componentId: "sc-1eq90u-11"
})(["&&{", "}"], ButtonStatesMixin);
export var getActionThemeConfig = function getActionThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return _objectSpread(_objectSpread({
        lineHeight: 1.3,
        useHoverStateForLoading: true,
        hoverTextDecoration: 'none'
      }, OutlineButtonConfigs), getDefaultSizeConfig(theme, {}));
    },
    fanta: _objectSpread({
      lineHeight: 1,
      useHoverStateForLoading: false,
      defaultBorderWidth: "".concat(2 / 16, "rem"),
      defaultBorderColor: colors.greyLight,
      defaultTextColor: colors.link,
      defaultBackgroundColor: colors.transparent,
      hoverBorderWidth: "".concat(2 / 16, "rem"),
      hoverBorderColor: colors.grey,
      hoverTextColor: colors.link,
      hoverBackgroundColor: colors.transparent,
      hoverTextDecoration: 'underline',
      disabledBorderWidth: "".concat(2 / 16, "rem"),
      disabledBorderColor: colors.greyLight,
      disabledTextColor: colors.tealMedium,
      disabledBackgroundColor: colors.transparent
    }, getFantaSizeConfig({})),
    prop: themeProp
  };
};
export var ActionButtonContainer = styled(ButtonContainer).withConfig({
  componentId: "sc-1eq90u-12"
})(["&&{", "}"], ButtonStatesMixin);
export var getCourseThemeConfig = function getCourseThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return _objectSpread({
        lineHeight: 1.3,
        defaultBackgroundColor: colors.white,
        defaultTextColor: colors.grey700,
        defaultBoxShadow: theme.boxShadow.elevation100,
        hoverBackgroundColor: colors.white,
        hoverTextColor: colors.grey900,
        hoverBoxShadow: theme.boxShadow.elevation200,
        disabledBorderWidth: "".concat(1 / 16, "rem"),
        disabledBorderColor: colors.grey200,
        disabledBackgroundColor: colors.white,
        disabledTextColor: colors.grey500,
        showChevronTrailingIcon: true
      }, getDefaultSizeConfig(theme, {}));
    },
    fanta: _objectSpread({
      lineHeight: 1,
      defaultTextColor: colors.dark,
      defaultBoxShadow: '0 0 16px rgba(34, 34, 34, 0.2)',
      hoverTextColor: colors.dark,
      hoverBoxShadow: '0 0 16px rgba(34, 34, 34, 0.5)',
      disabledBorderWidth: "".concat(2 / 16, "rem"),
      disabledBorderColor: colors.greyLight,
      disabledTextColor: colors.greyMedium,
      showChevronTrailingIcon: false
    }, getFantaSizeConfig({})),
    prop: themeProp
  };
};
export var CourseButtonContainer = styled(ButtonContainer).withConfig({
  componentId: "sc-1eq90u-13"
})(["", " &&{", "}"], function (_ref14) {
  var customTheme = _ref14.customTheme;
  return customTheme.showChevronTrailingIcon ? "\n    svg:last-child, svg + svg:last-child {\n      margin-left: auto;\n      margin-right: 0;\n    }\n    > span {\n      width: 100%;\n    }\n  " : '';
}, ButtonStatesMixin);
export var getIconThemeConfig = function getIconThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return _objectSpread({
        lineHeight: 1.3,
        defaultBoxShadow: theme.boxShadow.elevation100,
        hoverBoxShadow: theme.boxShadow.elevation200,
        disabledBoxShadow: 'none',
        simple: {
          defaultBoxShadow: 'none',
          hoverBoxShadow: 'none',
          defaultBackgroundColor: colors.transparent,
          defaultTextColor: colors.grey700,
          hoverBackgroundColor: colors.grey100,
          hoverTextColor: colors.grey900,
          disabledBackgroundColor: colors.transparent,
          disabledTextColor: colors.grey600
        },
        primary: {
          defaultBackgroundColor: gradient.horizon,
          defaultTextColor: colors.white,
          hoverBackgroundColor: colors.orange900,
          hoverTextColor: colors.white,
          disabledBackgroundColor: colors.grey200,
          disabledTextColor: colors.grey600
        },
        secondary: {
          defaultBackgroundColor: colors.grey900,
          defaultTextColor: colors.white,
          hoverBackgroundColor: colors.grey800,
          hoverTextColor: colors.white,
          disabledBackgroundColor: colors.grey200,
          disabledTextColor: colors.grey600
        },
        outlined: OutlineButtonConfigs
      }, getDefaultSizeConfig(theme, {
        xlarge: {
          size: 'medium',
          padding: "".concat(12 / 16, "rem")
        },
        large: {
          size: 'small',
          padding: "".concat(12 / 16, "rem")
        },
        medium: {
          size: 'small',
          padding: "".concat(8 / 16, "rem")
        },
        small: {
          size: 'small',
          padding: "".concat(4 / 16, "rem")
        },
        xsmall: {
          size: 'xsmall',
          padding: "".concat(4 / 16, "rem")
        }
      }));
    },
    fanta: _objectSpread({
      lineHeight: 1,
      defaultBoxShadow: undefined,
      hoverBoxShadow: undefined,
      disabledBoxShadow: undefined,
      simple: {
        defaultBackgroundColor: colors.transparent,
        defaultTextColor: colors.dark,
        hoverBackgroundColor: colors.transparent,
        hoverTextColor: colors.dark,
        disabledBackgroundColor: colors.transparent,
        disabledTextColor: colors.greyLight
      },
      primary: {
        defaultBackgroundColor: colors.transparent,
        defaultTextColor: colors.dark,
        hoverBackgroundColor: colors.transparent,
        hoverTextColor: colors.dark,
        disabledBackgroundColor: colors.transparent,
        disabledTextColor: colors.greyLight
      },
      secondary: {
        defaultBackgroundColor: colors.transparent,
        defaultTextColor: colors.dark,
        hoverBackgroundColor: colors.transparent,
        hoverTextColor: colors.dark,
        disabledBackgroundColor: colors.transparent,
        disabledTextColor: colors.greyLight
      },
      outlined: {
        defaultBorderWidth: 0,
        defaultBackgroundColor: colors.transparent,
        defaultTextColor: colors.dark,
        hoverBorderWidth: 0,
        hoverBackgroundColor: colors.transparent,
        hoverTextColor: colors.dark,
        disabledBorderWidth: 0,
        disabledBackgroundColor: colors.transparent,
        disabledTextColor: colors.greyLight
      }
    }, getFantaSizeConfig({
      xlarge: {
        size: 'large',
        padding: spacing.px4
      },
      large: {
        size: 'large',
        padding: 0
      },
      medium: {
        size: 'medium',
        padding: "".concat(5 / 16, "rem")
      },
      small: {
        size: 'small',
        padding: "".concat(9 / 16, "rem")
      },
      xsmall: {
        size: 'xsmall',
        padding: "".concat(13 / 16, "rem")
      }
    })),
    prop: themeProp
  };
};
export var IconButtonContainer = styled(ButtonContainer).withConfig({
  componentId: "sc-1eq90u-14"
})(["padding:", ";", ""], function (_ref15) {
  var customTheme = _ref15.customTheme,
      size = _ref15.size;
  return customTheme[size].padding;
}, ButtonStatesMixin);